/**
 * **Ein Tastenkürzel als Text, je Plattform und Sprache.**
 *
 * Geschrieben wird es in Mac-Schreibweise (`⌘D`, `⌘⇧W`, `⌘,`) — so steht es in
 * CONTEXT.md und im Code. Auf dem Mac bleibt es so; sonst wird ⌘ zu
 * `Strg+`/`Ctrl+` und ein ⇧ NEBEN ⌘ zu `Umschalt+`/`Shift+`, wie Windows es
 * schreibt (`Strg+Umschalt+W`). Ein ⇧ allein vor einem Buchstaben (`⇧D`) bleibt
 * ein Zeichen: Die Taste trägt es auch unter Windows.
 *
 * Für Kürzel als reinen Text (Menüzeilen, `aria-label`). Knöpfe und Tooltips
 * nehmen `ShortcutBadge` mit `mod: true`, das dieselbe Regel zeichnet.
 * Stand bis 2026-09-24 an sieben Stellen hart als ⌘ bzw. englisches `Ctrl`,
 * im Pinnwand-Menü (`⇧⌘↑`) bis v0.6.13.
 *
 * @example
 * shortcutText('⌘⇧W', { isMac: false, language: 'de' }) // 'Strg+Umschalt+W'
 */
export function shortcutText(mac: string, { isMac, language }: { isMac: boolean; language: string }): string {
  if (isMac) return mac
  // ⌥ ohne ⌘ (⇧⌥↑, #204): unter Windows Alt — Umschalt davor, wie Windows es schreibt.
  if (!mac.includes('⌘') && mac.includes('⌥')) {
    const shiftText = language.startsWith('de') ? 'Umschalt+' : 'Shift+'
    return (mac.includes('⇧') ? shiftText : '') + 'Alt+' + mac.replace('⌥', '').replace('⇧', '')
  }
  if (!mac.includes('⌘')) return mac
  const de = language.startsWith('de')
  const ctrl = de ? 'Strg+' : 'Ctrl+'
  const shift = de ? 'Umschalt+' : 'Shift+'
  // Der Mac schreibt ⇧ auch VOR ⌘ (`⇧⌘↑`); Windows nennt Strg immer zuerst.
  const withShift = mac.includes('⇧')
  const key = mac.replace('⌘', '').replace('⇧', '')
  return ctrl + (withShift ? shift : '') + key
}
